<template><div>
 <modalContent v-if="showDuplicateEntity"
        name="duplicate-entity" 
        ref="duplicateModal"
        :title="$t(`case_entity.creation.potential_matches_were_found_against_this_entity`)"
        width="70%"
        darkContent
        close
        @closed="onClose"
        >
            <template #content>
            <!-- <Loader v-if="isCloning" loadingText="Cloning Field..." /> -->

              <div class="custom-table-container">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>{{ idLabel }}</th>
                      <th v-if="getUserType !== 'CLIENT_INTERNAL'">{{ clientNameLabel }}</th>
                      <th>{{ usersWithAccessLabel }}</th>
                      <th>{{ packageNameLabel }}</th>
                      <th>{{ nameLabel }}</th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'company'">{{ emailLabel }}</th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'company'">{{ dunsNumberLabel }}</th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'person'">{{ countryLabel }}</th>
                      <th colspan="3" class="dob-header" v-if="selectedEntity?.type.toLowerCase() === 'person'">
                        {{ dobLabel }}
                        <div class="dob-subheaders">
                          <span>Day</span>
                          <span>Month</span>
                          <span>Year</span>
                        </div>
                      </th>
                      <th colspan="3" class="dob-header" v-if="selectedEntity?.type.toLowerCase() === 'company'">
                        {{ incorporationDateLabel }}
                        <div class="dob-subheaders">
                          <span>Day</span>
                          <span>Month</span>
                          <span>Year</span>
                        </div>
                      </th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'company'">{{ countryLabel }}</th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'company'">{{ companyNumberLabel }}</th>
                      <th v-if="selectedEntity?.type.toLowerCase() === 'person'">{{ emailLabel }}</th>
                    </tr>
                    </thead>
                  <tbody>
                   <tr v-for="(row, index) in rows" :key="`${row.case_id}-${index}`">
                      <td>
                        <a :href="`/case/${row.case_id}/profile-view?clientId=${row.client_id}&caseid=${row.case_uuid}&entityId=${row.case_entity_id}`" 
                          target="_blank" 
                          rel="noreferrer" 
                          class="text-blue-600 no-underline font-bold">
                          {{ row.case_id }}
                        </a>
                      </td>
                      <td v-if="getUserType !== 'CLIENT_INTERNAL'">{{ row.client_name }}</td>
                      <td>{{ row.access_users && Array.isArray(row.access_users) ? row.access_users.join(', ') : '' }}</td>
                      <td>{{ row.package_name }}</td>
                      <td>{{ row.match_status }}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'person'">{{ row.country }}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'company'"> {{row.email_address}}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'company'"> {{row.duns_number}}</td>
                      <td class="dob-cell">{{ row.day }}</td>
                      <td class="dob-cell">{{ row.month }}</td>
                      <td class="dob-cell">{{ row.year }}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'company'"> {{row.country}}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'company'"> {{row.company_number}}</td>
                      <td v-if="selectedEntity?.type.toLowerCase() === 'person'">{{ row.email_address }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            
            </template>
            <template #footer>
            <footer class="flex items-center w-full justify-between pt-4 border-t border-0 border-solid border-gray-200">
                    <div class="font-semibold">{{$t('case_entity.creation.potential_matches_were_found_against_this_entity')}}. {{$t('case_entity.creation.do_you_still_want_to_continue_with_entity_creation')}}?</div>
                    <div  class="flex ml-auto">
                        <button
                        class="h-9  cursor-pointerborder-none rounded-xl text-sm-base text-white-text flex justify-center items-center font-semibold mr-2 p-5"
                        :class="[isSubmitDisabled ? 'bg-gray-500 cursor-not-allowed pointer-events-none' :'bg-primary cursor-pointer hover:bg-primary-600']" @click = "discardEntity()"
                        >
                         <Loader  size="4" v-if="isDeletingEntity" />
                        {{ $t('case_entity.creation.no_discard_this_entity') }}
                        </button>
                        <button
                        class="h-9  cursor-pointerborder-none rounded-xl text-sm-base text-white-text flex justify-center items-center font-semibold ml-auto p-5"
                        :class="[isSubmitDisabled ? 'bg-gray-500 cursor-not-allowed pointer-events-none' :'bg-primary cursor-pointer hover:bg-primary-600']" @click ="saveEntity()"
                        >
                         <Loader  size="4" v-if="isCreatingEntity"/>
                        {{ $t('case_entity.creation.yes_continue_creating_the_entity') }}
                        </button>
                    </div>
            </footer>
            </template>
    </modalContent>
</div>
</template>
<script>
import modalContent from "@shared/modal-content";
import Loader from "@shared/loader/index.vue";

export default {
    components: {
        modalContent,
        Loader,
    },

  

props: {
    showDuplicateEntity: {
        type: Boolean,
        default: false,
    },
    rows: {
        type: Array,
        default: () => []
    },
    selectedEntity: {
        type: Object,
        default: () => {},
    },
    loadingState: {
        type: Boolean,
        default: false,
    },
    entityName: {
        type: String,
        default: '',
    },
    isDeletingEntity: {
        type: Boolean,
        default: false,
    },
    isCreatingEntity: {
        type: Boolean,
        default: false,
    },
    isSubmitDisabled: {
        type: Boolean,
        default: false,
    },
},


data() {
    return {
    }
},

watch: {
    showDuplicateEntity(newVal) {
        if (newVal) {
            this.$nextTick(() => {
                if (this.$refs.duplicateModal) {
                    this.$refs.duplicateModal.showModal();
                }
            });
        }
    }
},
  computed: {
    idLabel() {
      return this.$t('case_entity.creation.id');
    },
    clientNameLabel() {
      return this.$t('components.client_name');
    },
    usersWithAccessLabel() {
      return this.$t('case_entity.creation.users_with_access');
    },
    packageNameLabel() {
      return this.$t('pages.workflow_engine.package_name');
    },
    nameLabel() {
      return `${this.$t('components.tenant.email_template_modal.name')} (${this.entityName || ''})`;
    },
    getUserType() {
      return this.$store?.getters?.getUserType || '';
    },
    emailLabel() {
      return this.$t('pages.user_details.email');
    },
    dunsNumberLabel() {
      return this.$t('components.tools.company_identifier.company_info.duns_number');
    },
    countryLabel() {
      return this.$t('profile_view.sources_columns.country');
    },
    dobLabel() {
      return this.$t('components.saas.adverse_media.lexis_bridger.dob');
    },
    incorporationDateLabel() {
      return this.$t('components.tools.company_identifier.incorporation_date');
    },
    companyNumberLabel() {
      return this.$t('components.light_ray.company_number');
    },
},
methods: {
    onClose() {
        this.$refs.duplicateModal?.hideModal();
        this.$emit('closed');
    },
    
    discardEntity() {
        this.$refs.duplicateModal?.hideModal();
        this.$emit('discard');
    },
    
    saveEntity() {
        this.$refs.duplicateModal?.hideModal();
        this.$emit('save');
    }
}

}
</script>
<style>
</style>
